import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import authReducer from './features/auth/authSlice';
import uiReducer from './features/ui/uiSlice';
import carReducer from './features/car/carSlice';

const rootReducer = combineReducers({
    // slices here
    auth: authReducer,
    ui: uiReducer,
    car: carReducer,
});

const store = configureStore({
    reducer: rootReducer,
});
export default store;

export type IRootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<IRootState>();
